/**
 * Disclaimers Component
 *
 * IDX and extended disclaimers with collapsible behavior.
 */
const DISCLAIMERS = {
    // Always-visible, same tier as idx (see showAggregate) - for Sales
    // Data/Market Stats views, which aggregate across sales+listings from
    // multiple scopes/time windows rather than showing one listing's IDX
    // data, so the IDX attribution text isn't the relevant "basic"
    // disclaimer there; this is.
    aggregate: {
        text: 'Aggregate data is derived from multiple sources. While we make every attempt to be accurate, it may not perfectly match other sources, as boundaries and filters may differ. It should be used as directional vs definitive.',
    },
    idx: {
        text: `Listings provided courtesy of the REALTORS® Association of Maui.<br><br>IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. © ${new Date().getFullYear()} MLS Hawaii Inc. All rights reserved.`,
    },
    general: {
        title: 'General Information Disclaimer',
        text: 'Information on this website is provided for general informational purposes only. Data may come from public records, third-party providers, or automated systems, including AI. While believed to be reliable, accuracy and completeness are not guaranteed. Users should independently verify all information before making real estate decisions.',
    },
    mls: {
        title: 'MLS Disclaimer',
        text: 'Information is deemed reliable but not guaranteed. Data is provided by the REALTORS® Association of Maui MLS and may not reflect all real estate activity in the market. Listing information is deemed reliable but not guaranteed and should be independently verified. Property details, availability, and pricing may change without notice.',
    },
    ai: {
        title: 'AI & Automated Content Disclaimer',
        text: 'Some content on this website may be generated or assisted by automated systems or artificial intelligence and may contain errors or outdated information.',
    },
    neighborhood: {
        title: 'Neighborhood & Lifestyle Information Disclaimer',
        text: 'Neighborhood descriptions, schools, amenities, and community information are provided for general guidance only and should be independently verified.',
    },
};
export class Disclaimers {
    options;
    expanded;
    constructor(options) {
        this.options = {
            showIdx: true,
            showAggregate: false,
            showNeighborhood: false,
            startExpanded: false,
            ...options,
        };
        this.expanded = this.options.startExpanded || false;
    }
    render() {
        const { showIdx, showAggregate, showNeighborhood } = this.options;
        let html = `<div class="sm-disclaimer-container${this.expanded ? ' expanded' : ''}">`;
        // Aggregate-data disclaimer (always visible when included) - rendered
        // first, ahead of idx, per the "first disclaimer" placement this was
        // requested with.
        if (showAggregate) {
            html += `<div class="sm-disclaimer-idx">${DISCLAIMERS.aggregate.text}</div>`;
        }
        // IDX disclaimer (always visible when included)
        if (showIdx) {
            html += `<div class="sm-disclaimer-idx">${DISCLAIMERS.idx.text}</div>`;
        }
        // Toggle link
        html += `<button class="sm-disclaimer-toggle">More disclaimers...</button>`;
        // Extended disclaimers (hidden by default)
        html += '<div class="sm-disclaimer-extended">';
        // General disclaimer
        html += `
      <div class="sm-disclaimer-section">
        <strong>${DISCLAIMERS.general.title}</strong>
        ${DISCLAIMERS.general.text}
      </div>
    `;
        // MLS disclaimer
        html += `
      <div class="sm-disclaimer-section">
        <strong>${DISCLAIMERS.mls.title}</strong>
        ${DISCLAIMERS.mls.text}
      </div>
    `;
        // AI disclaimer
        html += `
      <div class="sm-disclaimer-section">
        <strong>${DISCLAIMERS.ai.title}</strong>
        ${DISCLAIMERS.ai.text}
      </div>
    `;
        // Neighborhood disclaimer (optional)
        if (showNeighborhood) {
            html += `
        <div class="sm-disclaimer-section">
          <strong>${DISCLAIMERS.neighborhood.title}</strong>
          ${DISCLAIMERS.neighborhood.text}
        </div>
      `;
        }
        html += '</div></div>';
        this.options.container.innerHTML = html;
        this.attachEventListeners();
    }
    attachEventListeners() {
        const toggle = this.options.container.querySelector('.sm-disclaimer-toggle');
        const disclaimerContainer = this.options.container.querySelector('.sm-disclaimer-container');
        if (toggle && disclaimerContainer) {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                this.expanded = !this.expanded;
                disclaimerContainer.classList.toggle('expanded', this.expanded);
                toggle.textContent = this.expanded ? 'Less disclaimers...' : 'More disclaimers...';
            });
        }
    }
    destroy() {
        this.options.container.innerHTML = '';
    }
}
//# sourceMappingURL=Disclaimers.js.map